import { SET_PLAN_DATA } from '../../actions/types/types';

const initState = {
  plan: [],
};

const GymReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_PLAN_DATA:
      return {
        ...state,
        plan: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default GymReducer;
